import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import { RegulatoryComponentWrapper } from './Components';

type UnavailableKidRegulatoryComponentProps = Readonly<{}>;

export const UnavailableKidRegulatoryComponent: FC<UnavailableKidRegulatoryComponentProps> = () => (
  <RegulatoryComponentWrapper
    componentId="kid-accordion"
    title="blotterPanel.KidDocumentAccordionTitle"
    isLoading={false}
    isInError={false}
  >
    <span data-e2e="kid-message">
      <FormattedMessage id="sidePanel.kidDocuments.unavailable" />
    </span>
  </RegulatoryComponentWrapper>
);

UnavailableKidRegulatoryComponent.displayName = 'UnavailableKidRegulatoryComponent';
